import React from 'react';
import LoginForm from '../../components/LoginForm/LoginForm';
import { Container } from 'reactstrap';

const Login = () => {
  return (
    <Container>
      <LoginForm />
    </Container>
  );
};

export default Login;
